import React from 'react';
import { Box, Typography, Avatar, IconButton, Tooltip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EventIcon from '@mui/icons-material/Event';
import { alpha } from '@mui/material/styles';
import OnlineDot from './OnlineDot';

const ChatHeader = ({
  selectedUser,
  selectedFullName,
  isMobile,
  isDark,
  theme,
  onlineUsers,
  onBack,
  onViewProfile,
  onScheduleMeeting,
  showScheduleMeeting = true,
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      px: { xs: 1.5, sm: 2.5 },
      py: 1.5,
      bgcolor: 'background.paper',
      borderBottom: '1px solid',
      borderColor: 'divider',
      gap: 1,
      flexShrink: 0,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
      {isMobile && (
        <IconButton
          size="small"
          onClick={onBack}
          sx={{ mr: 0.5, flexShrink: 0 }}
        >
          <ArrowBackIcon fontSize="small" />
        </IconButton>
      )}
      <Tooltip title="View Profile" arrow>
        <Box
          onClick={onViewProfile}
          sx={{ position: 'relative', flexShrink: 0, cursor: 'pointer' }}
        >
          <Avatar
            src={selectedUser?.image || undefined}
            alt={selectedFullName}
            sx={{
              width: 40,
              height: 40,
              bgcolor: 'primary.main',
              color: 'white',
              fontWeight: 700,
              fontSize: '1rem',
              transition: 'opacity 0.2s ease',
              '&:hover': { opacity: 0.85 },
            }}
          >
            {!selectedUser?.image && selectedFullName?.charAt(0)?.toUpperCase()}
          </Avatar>
          <OnlineDot
            isOnline={selectedUser ? onlineUsers.has(selectedUser._id) : false}
            paperBg={theme.palette.background.paper}
          />
        </Box>
      </Tooltip>

      <Box sx={{ minWidth: 0 }}>
        <Typography
          onClick={onViewProfile}
          variant="subtitle1"
          sx={{
            fontWeight: 700,
            color: 'text.primary',
            textTransform: 'capitalize',
            fontSize: '0.95rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            '&:hover': {
              color: 'primary.main',
              textDecoration: 'underline',
            },
            transition: 'color 0.2s ease',
          }}
        >
          {selectedFullName}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            fontWeight: 500,
            color:
              selectedUser && onlineUsers.has(selectedUser._id)
                ? '#44b700'
                : 'text.secondary',
          }}
        >
          {selectedUser && onlineUsers.has(selectedUser._id)
            ? 'Online'
            : 'Offline'}
        </Typography>
      </Box>
    </Box>

    {showScheduleMeeting && (
    <Tooltip title="Schedule a Meeting" arrow>
      <Box
        onClick={onScheduleMeeting}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.75,
          px: { xs: 1.5, sm: 2 },
          py: 0.75,
          borderRadius: 2.5,
          border: '1.5px solid',
          borderColor: 'primary.main',
          color: 'primary.main',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          flexShrink: 0,
          bgcolor: isDark
            ? alpha(theme.palette.primary.main, 0.1)
            : 'transparent',
          '&:hover': {
            bgcolor: 'primary.main',
            color: 'white',
            transform: 'translateY(-1px)',
            boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.35)}`,
          },
        }}
      >
        <EventIcon sx={{ fontSize: 18 }} />
        <Typography
          variant="caption"
          sx={{
            fontWeight: 600,
            fontSize: '0.8rem',
            display: { xs: 'none', sm: 'block' },
            color: 'inherit',
          }}
        >
          Schedule Meeting
        </Typography>
      </Box>
    </Tooltip>
    )}
  </Box>
);

export default ChatHeader;
